export default __webpack_public_path__ + "static/assets/med_pill_square_out_L2_solid_l_01_f_mask.805b64d9.png";